import BackgroundWrapper   from "_components/atoms/backgroundWrapper";
import { SecondaryButton } from "_components/atoms/button";
import useStyles           from "./styles";

const component = props => {
	const {
		activeUpdateTab,
		changeUpdateTab
	} = props;

	const { classes } = useStyles ( undefined, { name: "notificationHeaderTabs" } );

	return (
		<BackgroundWrapper
			className = { classes.container }
			type      = "tertiary"
		>

			<SecondaryButton
				active              = { activeUpdateTab === "updates" }
				buttonTextClassName = { `${ activeUpdateTab === "updates" ? `${ classes.textStyles }` : `${ classes.textStyles }` }` }
				className           = { classes.button }
				onClick             = { () => changeUpdateTab ( "updates" ) }
				title               = { "All Updates" }
			/>

			<SecondaryButton
				active              = { activeUpdateTab === "features" }
				buttonTextClassName = { `${ activeUpdateTab === "features" ? `${ classes.textStyles }` : `${ classes.textStyles }` }` }
				className           = { classes.button }
				onClick             = { () => changeUpdateTab ( "features" ) }
				title               = { "New Features" }
			/>

			<SecondaryButton
				active              = { activeUpdateTab === "announcements" }
				buttonTextClassName = { `${ activeUpdateTab === "announcements" ? `${ classes.textStyles }` : `${ classes.textStyles }` }` }
				className           = { classes.button }
				onClick             = { () => changeUpdateTab ( "announcements" ) }
				title               = { "Announcements" }
			/>

		</BackgroundWrapper>
	);
};

export default component;
